<template>
  <div class='container-fluid' style='height:100vh;width:100vw'>
    <div class='spinner-container' v-if='loading == 1'>
      <div id='loader'></div>
    </div>
    <div class='row'>
      <div class='col-lg-2 col-md-2' style="paddingLeft:0px; paddingRight:0px">
        <Sidebar/>
      </div>

      <div class='col-lg-10 col-md-10 col-12 mt-2 dev animate-bottom pt-3'>
        <div class="row text-center">
          <div class="col-6 col-sm-6 p-2 background-color" :class="[state=='Add Comapny' ? 'activeState' : '']" @click="state='Add Comapny'">
            Add Company
          </div>
          <div class="col-6 col-sm-6 p-2 background-color" :class="[state=='Add Customer' ? 'activeState' : '']" @click="state='Add Customer'">
            Add Customer
          </div>
          <!-- <div class="col-4 col-sm-4 p-2 background-color" :class="[state=='Add Device' ? 'activeState' : '']" @click="state='Add Device'">
            Add Device
          </div> -->
        </div>
        <div class="row">
          <addCompany v-if="state=='Add Comapny'"></addCompany>
          <addCustomer v-if="state=='Add Customer'"></addCustomer>
          <!-- <addDevice v-if="state=='Add Device'"></addDevice> -->
        </div>
      </div>
    </div>

    <div
      class='modal fade bd-example-modal-lg'
      data-backdrop='static'
      data-keyboard='false'
      tabindex='-1'
    >
      <div class='modal-dialog modal-sm'>
        <div class='modal-content' style='width: 48px'>
          <span class='fa fa-spinner fa-spin fa-3x'></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { apiCall } from '@/utils/api';
import Sidebar from './Sidebar';
import addCompany from './crud operations/addCompany';
import addCustomer from './crud operations/addCustomer';
import addDevice from './crud operations/addDevice';
// import _ from 'underscore';

export default {
  components: {
    Sidebar,
    addCompany,
    addCustomer,
    addDevice,
  },
  data() {
    return {
      loading: 0,
      state: 'Add Comapny',
    };
  },
  mounted() {
  },
  computed: {
  },
  methods: {
  },
};
</script>
<style>
.activeState {
  background: #2295c8 !important;
  color: white;
}
.container-fluid {
  margin: 0px;
  padding: 0px;
}
.ubuntu-small {
  font-family: Ubuntu;
  font-weight: 200;
  font-size: 10px;
  color: rgba(59, 59, 59, 0.8);
}
.ubuntu-medium {
  font-family: Ubuntu;
  font-weight: 500;
  font-size: 14px;
  color: rgba(59, 59, 59, 0.8);
}
.dev {
  font-family: Ubuntu;
  font-weight: 200;
  color: rgba(59, 59, 59, 0.8);
  padding-left: 3.5rem !important;
  padding-right: 2.2rem !important;
}
a {
  /* color: rgba(59, 59, 59, 0.8); */
  text-decoration: none;
}
.btn:focus {
  box-shadow: none;
}
.form-control {
  color: rgba(59, 59, 59, 0.8);
  font-family: Ubuntu;
  font-weight: 200;
  font-size: 13px;
  height: 2rem !important;
}
.option:hover {
  color: #2295c8;
  background-color: transparent;
}
.form-control:focus {
  box-shadow: none;
  border: none;
}
.option:focus {
  background-color: transparent;
  border: none;
}
.form-check-input {
  margin-top: 0.7rem;
}
.listofdev {
  box-shadow: 0 0.5rem 0.5rem rgba(0, 0, 0, 0.2);
  border-top: none !important;
  padding-left: 0px;
  padding-right: 0px;
}
.srchfilter {
  border-bottom: none !important;
  /* background-color: #2295c8; */
  background-color: rgba(0, 0, 0, 0.1);
  width: 100%;
  border: 1px solid #dedede;
  padding-top: 5px;
  padding-bottom: 5px;
}
a:link {
  text-decoration: none;
}
a {
  color: rgba(59, 59, 59, 0.8);
}
a:hover {
  color: #2295c8;
}
.bd-example-modal-lg .modal-dialog {
  display: table;
  position: relative;
  margin: 0 auto;
  top: calc(50% - 24px);
}

.bd-example-modal-lg .modal-dialog .modal-content {
  background-color: transparent;
  border: none;
}

.model {
  display: block;
}

.count-row {
  font-size: 20px;
}
.back{
  cursor: pointer;
}
#loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.6;
  z-index: 1;
  margin: -15px;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Add animation to 'page content' */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s;
}

@-webkit-keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0px;
    opacity: 1;
  }
}

@keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}

.background-color {
  background: #dbf3fa;
}
</style>
